<template>
  <b-container>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="3">
            <h4>Web Browser</h4>
          </b-col>
          <b-col>
            <b-checkbox v-model="notifications.web.sound"
              >Play Sound</b-checkbox
            >
          </b-col>
        </b-row>
        <b-checkbox v-model="notifications.web.all">All Activities</b-checkbox>
        <b-checkbox v-model="notifications.web.join">Join Requests</b-checkbox>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="3">
            <h4>Mobile Push</h4>
          </b-col>
          <b-col>
            <b-checkbox v-model="notifications.mobile.sound"
              >Play Sound</b-checkbox
            >
          </b-col>
        </b-row>
        <b-checkbox v-model="notifications.mobile.all"
          >All Activities</b-checkbox
        >
        <b-checkbox v-model="notifications.mobile.join"
          >Join Requests</b-checkbox
        >
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="3">
            <h4>Email</h4>
          </b-col>
        </b-row>
        <b-checkbox v-model="notifications.email.newfocusdetail"
          >New Focused Journey Details</b-checkbox
        >
        <b-checkbox v-model="notifications.email.join"
          >Join Requests
        </b-checkbox>
        <b-checkbox v-model="notifications.email.weeklyreport"
          >Weekly "On Track" Report</b-checkbox
        >
        <b-checkbox v-model="notifications.email.monthlyreport"
          >Monthly Summary Report</b-checkbox
        >
        <b-checkbox v-model="notifications.email.tips"
          >Helpful Tips About My Journey</b-checkbox
        >
      </b-col>
    </b-row>
    <b-button variant="success" class="mt-4" @click.prevent="saveSettingsNotif"
      >Save</b-button
    >
  </b-container>
</template>
<script>
import firebase from "firebase";
import MyUpload from "vue-image-crop-upload";
export default {
  components: {
    MyUpload
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    saveSettingsNotif() {
      let dataToUpdate = { settings: { notifications: this.notifications } };
      this.$store.dispatch("user/updateProfile", dataToUpdate).then(res => {
        if (res) {
          this.$store.dispatch("user/getProfile").then(() => {
            console.log(`save settings notifications !!!`);
          });
        }
      });
    }
  },
  computed: {
    hasUpdates() {
      return true;
      /*return this.firstname !==  this.user.profile ? this.user.profile.firstname : null ||
                this.lastname !==  this.user.profile ? this.user.profile.lastname : null ||
                this.username !==  this.user.profile ? this.user.profile.username : null ||
                this.about !==  this.user.profile ? this.user.profile.about : null ||
                this.phone !==  this.user.profile ? this.user.profile.phone : null ;*/
    }
  },
  data: function() {
    return {
      notifications: {
        web: {
          all:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.web &&
            this.profile.settings.notifications.web.all
              ? this.profile.settings.notifications.web.all
              : false,
          join:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.web &&
            this.profile.settings.notifications.web.join
              ? this.profile.settings.notifications.web.join
              : false,
          sound:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.web &&
            this.profile.settings.notifications.web.sound
              ? this.profile.settings.notifications.web.sound
              : false
        },
        mobile: {
          all:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.mobile &&
            this.profile.settings.notifications.mobile.all
              ? this.profile.settings.notifications.mobile.all
              : false,
          join:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.mobile &&
            this.profile.settings.notifications.mobile.join
              ? this.profile.settings.notifications.mobile.join
              : false,
          sound:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.mobile &&
            this.profile.settings.notifications.mobile.sound
              ? this.profile.settings.notifications.mobile.sound
              : false
        },
        email: {
          newfocusdetail:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email &&
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email.newfocusdetail
              ? this.profile.settings.notifications.email.newfocusdetail
              : false,
          join:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email &&
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email.join
              ? this.profile.settings.notifications.email.join
              : false,
          weeklyreport:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email &&
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email.weeklyreport
              ? this.profile.settings.notifications.email.weeklyreport
              : false,
          monthlyreport:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email &&
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email.monthlyreport
              ? this.profile.settings.notifications.email.monthlyreport
              : false,
          tips:
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email &&
            this.profile.settings &&
            this.profile.settings.notifications &&
            this.profile.settings.notifications.email.tips
              ? this.profile.settings.notifications.email.tips
              : false
        }
      }
    };
  }
};
</script>
